import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

export const QuestionWrapper = ({
  questionNumber,
  totalQuestions,
  questionText,
  helperText,
  children
}) => (
  <Stack spacing={3}>
    <Stack spacing={1}>
      {questionNumber && totalQuestions && (
        <Text
          color="primary"
          size="xs"
        >
          Question {questionNumber} of {totalQuestions}
        </Text>
      )}
      <Text
        color="secondary"
        size="xl"
        weight="bold"
      >
        {questionText}
      </Text>
      {helperText && (
        <Text
          color="tertiary"
          size="md"
        >
          {helperText}
        </Text>
      )}
    </Stack>
    {children}
  </Stack>
);

QuestionWrapper.propTypes = {
  questionNumber: PropTypes.number,
  totalQuestions: PropTypes.number,
  questionText: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  children: PropTypes.node
};
